import styled, { AnyStyledComponent } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, Markdown } from 'react-components'

import DownArrowImage from '../../assets/images/down-arrow.svg'
import UpArrowImage from '../../assets/images/up-arrow.svg'

export const Section = styled.div`
    padding: 0 0.625rem 2.5rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.25rem 4.375rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 1.25rem 1.6875rem;
    }
`

export const InnerContainer = styled.div`
    border-radius: ${props => props.theme.typography.border.radius.small};
    box-shadow: 0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1);
    border: solid 0.0625rem ${props => props.theme.colors.tfwYellow};
    background-color: ${props => props.theme.colors.tfwYellow10};
    box-sizing: border-box;
    margin: 0 auto;
    padding: 1.625rem 1.25rem 1.25rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1.375rem 1.25rem;
        display: ${props => props.theme.style.display.flex};
        flex-direction: ${props => props.theme.style.flexDirection.row};
        max-width: 1110px;
    }
`

export const ContentContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    margin-top: 1.25rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 0;
    }
`

export const DownArrow = styled(DownArrowImage as AnyStyledComponent)`
    width: 0.625rem;
    height: 0.625rem;
`

export const UpArrow = styled(UpArrowImage as AnyStyledComponent)`
    width: 0.625rem;
    height: 0.625rem;
`

export const TitleContainer = styled.h2`
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-size: 1.375rem;
    word-break: break-word;
    font-weight: normal;
    color: ${props => props.theme.colors.tfwBlack87};
    margin: 0;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1.5rem;
    }
`

export const DescriptionContainer = styled.p`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    line-height: normal;
    color: ${props => props.theme.colors.tfwBlack87};
    font-weight: 300;
    margin: 0.5rem 0 0.875rem;
`

export const LogoContainer = styled.img`
    width: 46px;
    height: 46px;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0.25rem 1.875rem 0 0;
    }
`

export const ExtraContentContainer = styled.div`
    word-break: break-word;
`

export const ExtraContentTitle = styled.p`
    display: inline;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    text-decoration: underline;
    line-height: normal;
    color: ${props => props.theme.colors.tfwBlack87};
    margin: 0;
    cursor: pointer;
`

export const ExtraContentDescription = styled(Markdown)<{ isVisible: boolean }>`
    ${({ isVisible }) => !isVisible && `display: none`};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    line-height: normal;
    font-weight: 300;
    margin: 0.5rem 0 0;
    & > p > a {
        color: ${props => props.theme.colors.tfwBlack87};
        font-weight: normal;
    }
`
